import script from "./authSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./authSystem.vue?vue&type=script&setup=true&lang=js"

import "./authSystem.vue?vue&type=style&index=0&id=0a617e9a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a617e9a"]])

export default __exports__